import { z } from 'zod';

/**
 * Schema for placeholder component.
 *
 * Placeholder is a minimal component for reserving space in dashboard layouts.
 * Useful during development or when content is not yet available.
 */
export const PlaceholderSchema = z.object({
  type: z.literal('placeholder').describe('Placeholder component type'),
  label: z.string().optional().describe('Optional label text to display in the placeholder'),
});

/** @public Input type for PlaceholderSchema - use for component props */
export type PlaceholderSchemaInput = z.input<typeof PlaceholderSchema>;

/** @public Output type for PlaceholderSchema - use after Zod parsing */
export type PlaceholderSchemaOutput = z.output<typeof PlaceholderSchema>;
